export const createEmptyVariant = (basePrice = '') => ({
  sku: '',
  price: basePrice,
  isAvailable: true,
  attributes: [{ option_name: 'color', option_value: '' }],
  media: [],
});

export const mapProductVariantsFromApi = (variants = []) =>
  (Array.isArray(variants) ? variants : []).map((variant) => ({
    sku: variant.sku || '',
    price: variant.price !== undefined && variant.price !== null ? String(variant.price) : '',
    isAvailable: variant.isAvailable !== false,
    attributes: (variant.attributes || []).length
      ? variant.attributes.map((attr) => ({
        option_name: attr.option_name || 'color',
        option_value: attr.option_value || '',
      }))
      : [{ option_name: 'color', option_value: '' }],
    media: (variant.images || []).map((img, index) => ({
      type: 'existing',
      mediaType: 'image',
      url: img.image || '',
      thumbnail: img.thumbnail || img.image || '',
      order: String(img.order ?? index + 1),
    })),
  }));

export const validateVariants = (variants = []) => {
  for (let i = 0; i < variants.length; i += 1) {
    const variant = variants[i];
    const price = Number(variant.price);
    if (!variant.price || Number.isNaN(price) || price <= 0) {
      return `Please enter a valid price for Variant No. ${i + 1}`;
    }
    if (!variant.attributes?.length) {
      return `Please add at least one attribute to Variant No. ${i + 1}`;
    }
    for (const attr of variant.attributes) {
      if (!String(attr.option_value || '').trim()) {
        return `Please fill in all attribute values for Variant No. ${i + 1}`;
      }
    }
  }
  return null;
};

export const buildVariantsSubmitPayload = (variants = []) => {
  const variantsData = [];
  const variantImageFiles = [];

  variants.forEach((variant, vIdx) => {
    const mediaPayload = (variant.media || []).map((item, mIdx) => {
      if (item.type === 'new' && item.file) {
        variantImageFiles.push(item.file);
        return {
          mediaType: 'image',
          type: 'new',
          order: String(item.order || mIdx + 1),
        };
      }
      return {
        mediaType: 'image',
        type: 'existing',
        url: item.url,
        thumbnail: item.thumbnail || item.url,
        order: String(item.order || mIdx + 1),
      };
    });

    variantsData.push({
      sku: variant.sku || `${vIdx + 1}_${Date.now()}`,
      price: variant.price,
      isAvailable: variant.isAvailable !== false,
      attributes: variant.attributes || [],
      media: mediaPayload,
    });
  });

  return { variantsData, variantImageFiles };
};
